import { useContext } from 'react';
import { sumBy, filter } from 'lodash';
import { STEPS } from './steps';
import { toMoney } from './filters';
import Summary from './Summary';
import WidgetContext from './WidgetContext';

export default function CheckoutSummary({ emptyLabel}) {
    const { contingents, automaticDiscountCodes, discountCodes, setStep } = useContext(WidgetContext);
    const disabled = !sumBy(contingents, 'count');

    return (
        <div className="h-full rounded flex flex-col justify-end items-center">
          <Summary contingents={contingents} automaticDiscountCodes={automaticDiscountCodes} discountCodes={discountCodes} />
          <button
            disabled={disabled}
            className={`rg-button my-2 lg:my-8 ${disabled ? 'disabled' : ''}`}
            onClick={() => setStep(STEPS.CHECKOUT)}>
            {!disabled ? 'zur Kasse gehen' : emptyLabel || 'Tickets wählen...'}
          </button>
        </div>
    );
}

